module.exports = __webpack_public_path__ + "static/media/Checked.afd96d8a.svg";